"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = useMenuControls;
const react_1 = __importDefault(require("react"));
const dropdown_context_1 = __importDefault(require("../../dropdown-context"));
const device_1 = require("~/helpers/device");
function useMenuControls({ topRef, label }) {
    const { setSubmenuLabel, setActiveDropdown } = (0, dropdown_context_1.default)();
    return react_1.default.useMemo(() => {
        function closeMenu() {
            setActiveDropdown({});
        }
        function closeDesktopMenu() {
            if (!(0, device_1.isMobileDisplay)()) {
                closeMenu();
            }
        }
        function openMenu(event) {
            event.preventDefault();
            setActiveDropdown(topRef);
            setSubmenuLabel(label);
            if ((0, device_1.isMobileDisplay)()) {
                event.target.blur();
            }
        }
        function openDesktopMenu(event) {
            event.preventDefault();
            if (!(0, device_1.isMobileDisplay)()) {
                openMenu(event);
            }
        }
        return {
            closeMenu,
            closeDesktopMenu,
            openMenu,
            openDesktopMenu
        };
    }, [label, setActiveDropdown, setSubmenuLabel, topRef]);
}
